import styled from "styled-components";
import designSystemColors from "../../styles";

export const Container = styled.div`
  width: 100%;
  background-color: ${designSystemColors.textGeneralButtons};
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
`;

export const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 2rem;
`;

export const PageTitle = styled.h1`
  font-size: 24px;
  color: ${designSystemColors.textDark};
  font-weight: bold;
  line-height: 20px;
`;

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${designSystemColors.backgroundGray};
`;

export const SubTileWrapper = styled.div`
  width: 95%;
  display: flex;
  align-items: flex-start;
  border-bottom: 1px solid ${designSystemColors.backgroundGray};
  margin-bottom: 4rem;
`;

export const SubTitle = styled.h2`
  font-size: 20px;
  color: ${designSystemColors.textDark};
  font-weight: bold;
  line-height: 20px;
`;

export const Content = styled.div`
  width: 90%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;

export const LoadingContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4rem;
`;
